import { useTranslation } from '@mint-lib/i18n';
import { Card, Chip, typographyVariants } from '@mint-lib/tw-components';

import { INTEGRATION_TYPES_NEW } from '../../../constants/ComponentsConstants.jsx';
import { getIntegrationTypeDescription } from '../../../constants/DescriptionsOfIntegrations.js';

type Props = {
  type: 'one_way' | 'two_way' | 'virtual';
};

const IntegrationTypeCard = ({ type }: Props) => {
  const { t } = useTranslation('@myn/integrations_v2');
  const typeProps = INTEGRATION_TYPES_NEW(t)[type];

  return (
    <Card className="h-full w-full p-2">
      <div className="mb-4">
        <h4 className={typographyVariants({ variant: 'h4' })}>
          {t('Integration type')}
        </h4>
      </div>
      <div className="mb-4">
        <Chip color={typeProps?.chipProps?.color} variant="outline">
          {typeProps?.chipProps?.icon}
          {typeProps?.chipProps?.label}
        </Chip>
      </div>
      <p className={typographyVariants({ variant: 'bodyLong01' })}>
        {getIntegrationTypeDescription(type, t)}
      </p>
    </Card>
  );
};

export default IntegrationTypeCard;
